export const formatoMoeda = (valor: any) => {
    if (!valor && valor !== 0) {
        return '';
    }
    return Number.parseFloat(valor).toLocaleString('pt-BR',
		{ style: 'currency', currency: 'BRL', minimumFractionDigits : 2, maximumFractionDigits : 2 });
};

export const formatoPercentual = (valor: any) => {
    if (!valor) {
        return '';
    }
    return Number.parseFloat(valor).toFixed(2) + ' %';
};

const units = ['B', 'KB', 'MB', 'GB', 'TB'];
const log1000 = Math.log(1000);

export const formatoBytes = (bytes: number, decimalPoint = 1): string => {

    if (bytes === 0) {
        return '0 B';
    }
    const i = Math.floor(Math.log(bytes) / log1000);
    return parseFloat((bytes / Math.pow(1000, i)).toFixed(decimalPoint)) + ' ' + units[i];
};

export const fomrmatarBrasileiro = (valor: number): string => {
	return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
